import StatusBadge from './status-badge';
export type { TTagSize, TTagVariant } from './status-badge.types';

export default StatusBadge;
